<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $tc("aggregator", 1) }} {{ $tc("user", 1) }}
        </div>
        <div class="section-subTitle my-2">{{ $t("cinemauser") }}</div>
      </div>
      <div>
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <b-button
          v-if="$can('create', 'Aggregator User')"
          variant="default"
          to="/user-management/add-aggregator"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getUserList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class>
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <table class="list-view-table">
      <thead>
        <tr>
          <th class="text-left">
            <div class="pr-3">{{ $tc("status", 1) }}</div>
          </th>
          <th>
            <div>
              <img
                v-if="this.columnName != 'first_name'"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('first_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("name", 2) }}
            </div>
          </th>
          <!-- <th>
            <div>{{ $tc('cinema', 1) }}</div>
          </th>
          <th>
            <div>{{ $tc('role', 1) }}</div>
          </th>-->
          <th>
            <div>{{ $t("token") }}</div>
          </th>
          <th>
            <div></div>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(user, userKey) in users" :key="userKey">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="user.user_is_active === 'Y' ? 'active' : 'inactive'"
              ></StatusDot>

              <div
                v-if="
                  user.user_id !== userid && $can('update', 'Aggregator User')
                "
                @click="onEditUser(user)"
                class="btn-icon ml-4"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </div>

              <div
                @click="onViewUser(user)"
                class="btn-icon ml-2"
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </div>
              <div
                @click="onGenerateToken(user)"
                class="btn-icon ml-2"
                style="cursor: pointer"
                v-b-tooltip="'Generate Token'"
                tabindex="0"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#8d6fbf"
                  class="bi bi-key-fill"
                  viewBox="0 0 22 22 "
                >
                  <path
                    d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                  />
                </svg>
              </div>
            </div>
          </td>

          <td>
            {{ user.first_name }} {{ user.middle_name }} {{ user.last_name }}
          </td>
          <!-- <td>{{ user.cinemaname }}</td> -->
          <!-- <td>{{ user.rolename }}</td> -->
          <td v-if="user.user_token && user.user_token.length > 0">
            {{ user.user_token || "N/A" }}
            <img
              @click="onCopyToken(user.user_token)"
              src="@/assets/img/icons/copy_image_icon.png"
              width="15px"
              height="15px"
            />
          </td>
          <td v-else>
            <button
              @click="onCreateNewToken(user.user_id, userKey)"
              class="btn-blue w-85"
            >
              Create Token
            </button>
          </td>
          <td>
            <button
              v-b-modal.editPassword
              v-if="$can('update', 'Aggregator User')"
              @click="selectedUser(user.user_id)"
              class="btn-blue w-85"
            >
              Edit Password
            </button>
          </td>
        </tr>
      </tbody>

      <b-modal id="editPassword" title="Change Password" hide-footer>
        <form>
          <div class="row mb-2 mx-0">
            <div class="col-12">
              <div
                class="col-lg-10 mx-auto align-self-center"
                v-if="showcurrentpassword"
              >
                <div class="text-center">
                  <p class="text-muted fs-14">
                    Enter your current password to proceed further
                  </p>
                  <div class="input-material">
                    <input
                      type="password"
                      v-model="password"
                      name="currentpass"
                      id="currentpass"
                      v-validate="'required'"
                      placeholder="."
                    />
                    <label>Current Password</label>
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && errors.has('currentpass')">{{
                      errors.first("currentpass")
                    }}</span>
                  </p>

                  <button
                    @click.prevent.stop="$bvModal.hide('editPassword')"
                    class="btn-outline-blue"
                  >
                    Cancel
                  </button>
                  <button
                    @click.prevent.stop="ProceedtoNewPassword"
                    class="btn-blue"
                  >
                    Proceed
                  </button>
                </div>
              </div>

              <div
                class="col-lg-10 pl-5 align-self-center"
                v-if="shownewpassword"
              >
                <div>
                  <div class="mb-3">
                    <div class="input-material">
                      <input
                        type="password"
                        v-model="epassword"
                        name="forgotpassword"
                        id="forgotpassword"
                        ref="forgotpassword"
                        v-validate="{
                          required: 'required',
                          regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,
                        }"
                        placeholder="."
                        autofocus
                      />
                      <label>Enter New Passowrd</label>
                    </div>
                    <p class="error_msg">
                      <span
                        v-if="submitted && errors.has('forgotpassword')"
                        class="error_message"
                        >{{ errors.first("forgotpassword") }}</span
                      >
                    </p>
                  </div>
                  <div class="mb-3">
                    <div class="input-material">
                      <input
                        type="password"
                        v-model="cpassword"
                        name="forgotconfirm"
                        id="forgotconfirm"
                        v-validate="'required|confirmed:forgotpassword'"
                        placeholder="."
                        autofocus
                      />
                      <label>Confirm Passowrd</label>
                    </div>
                    <p class="error_message">
                      <span
                        v-if="submitted && errors.has('forgotconfirm')"
                        class="error_message"
                        >{{ errors.first("forgotconfirm") }}</span
                      >
                    </p>
                  </div>
                  <div class="d-flex">
                    <button
                      @click.prevent.stop="$bvModal.hide('editPassword')"
                      class="btn-white-lg w-50 mr-2"
                    >
                      Cancel
                    </button>
                    <button
                      @click.prevent.stop="onFinalProceed"
                      class="btn-blue-lg w-50 ml-2"
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-6">
              <div class="text-center mb-4 pb-2 mt-3">
                <h4>New Password</h4>
              </div>
            </div>-->
          </div>
        </form>
      </b-modal>

      <b-modal
        title="Token"
        hide-backdrop
        hide-footer
        hide-header
        centered
        ref="getTokenModal"
        id="getTokenModal"
        class="seat_select_modal"
      >
        <div class="text-center">
          <p class="font-weight-bold text-blue mb-3">
            Aggregator Token For:&nbsp;
            <span class="fs-14 text-underline">{{
              tokenDetails.token_user
            }}</span>
          </p>
          <div class="d-flex justify-content-center">
            <div class="font-weight-bold fs-10" style="word-break: break-all">
              {{ tokenDetails.token }}
            </div>
          </div>

          <div class="row text-center mx-auto">
            <div
              @click="copyKeyValue(tokenDetails.token)"
              class="btn btn-sm btn-primary mx-auto mt-3"
            >
              Copy
            </div>
          </div>
        </div>
      </b-modal>

      <tbody v-if="users.length == 0">
        <tr>
          <td colspan="4">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
  import UserService from "@/services/UserService";
  import MasterService from "@/services/MasterService";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  export default {
    components: {
      StatusDot,
      FilterByStatusDropdown,
      NoRecords,
    },
    data() {
      return {
        tokenDetails: {
          token: "",
          token_user: "",
        },
        searchValue: "",
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",

        showcurrentpassword: true,
        shownewpassword: false,
        password: "",
        submitted: false,
        selectUser: "",
        epassword: "",
        cpassword: "",

        gridView: false,
        listView: true,
        users: [],
        Cinemas: [],
        cinemaname: "",
        rolename: "",
        CinemasMethods: {
          GET: "/admin/",
          tableName: "ms_cinemas",
          urlKey: "cinemas",
        },
        Roles: [],
        RolesMethod: {
          GET: "/admin/",
          tableName: "ms_roles",
          urlKey: "roles",
        },
        userid: "",
        //sorting
        isSort: false,
        isAscending: false,
        columnName: "",
        orderBy: "",
      };
    },
    computed: {
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }

        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);

        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
    },

    mounted() {
      this.getUserList();
    },
    beforeMount() {
      const { user_id } = this.secureStore.get("USINFO");
      this.userid = user_id;
      this.getviewingnumber();
    },
    methods: {
      onGenerateToken(user) {
        let payload = {
          user_id: user.user_id,
        };
        MasterService.GenerateAggToken(payload)
          .then((response) => {
            const { data } = response;

            if (data && data.status) {
              Object.keys(data.tokenObj).map((x) => {
                this.tokenDetails[x] = data.tokenObj[x];
              });
              this.$bvModal.show("getTokenModal");
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
      selectedUser(value) {
        console.log("value :", value);
        this.selectUser = value;
        console.log("this.selectUser :", this.selectUser);
        console.log("showcurrentpassword :", this.showcurrentpassword);
        console.log("shownewpassword :", this.shownewpassword);
      },
      OnCloseModal() {
        this.$bvModal.hide("editPassword");
        this.shownewpassword = false;
        this.showcurrentpassword = true;
        this.password = "";
      },
      ProceedtoNewPassword() {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          if (valid) {
            let payload = {
              userid: this.selectUser,
              userpassword: this.password,
            };
            UserService.VerifyCurrentPassword(payload).then((response) => {
              console.log("response :", response);
              const { data } = response;
              if (data.status) {
                this.$toasted.show(data.message);
                this.showcurrentpassword = false;
                this.shownewpassword = true;
              } else {
                this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
              }
            });
          }
        });
      },
      onCreateNewToken(user_id, index) {
        let payload = {
          user_id: user_id,
          role_id: 10,
        };
        UserService.CreateNewToken(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.users[index].user_token = data.token;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          })
          .catch((err) => {
            this.$toasted.show(
              "Sorry! Something went wrong. kindly contact your administrator"
            );
          });
      },
      copyKeyValue(copy_data) {
        navigator.clipboard.writeText(copy_data);
        this.$toasted.show("Token Copied");
      },
      onCopyToken(token) {
        this.$copyText(token)
          .then((e) => {
            if (e.action == "copy") {
              this.$toasted.show("Token Copied");
            } else {
              this.$toasted.show("Token Can not Copy");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
      onFinalProceed() {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          if (valid) {
            // let loader = this.$loading.show();
            let payload = {
              userid: this.selectUser,
              password: this.cpassword,
            };

            UserService.UpdateChangePassword(payload).then((response) => {
              console.log("response :", response);
              const { data } = response;

              if (data.status) {
                this.$toasted.show(data.message);
                this.$bvModal.hide("editPassword");
                this.epassword = "";
                this.cpassword = "";
                this.password = "";
                this.showcurrentpassword = true;
                this.shownewpassword = false;
              } else {
                this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
              }
            });
          }
        });
      },
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },
      /* eslint-disable */
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.getUserList();
        } else {
          this.currentPage = event;
          this.getUserList();
        }
      },
      onSortValue(columnName, orderBy) {
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderBy = orderBy;
        this.getUserList();
      },
      getUserList: function() {
        let body = {
          limit: this.perPage,
          currentPage: this.currentPage,
          searchValue: this.searchValue,
          columnName: this.columnName,
          orderBy: this.orderBy,
        };
        UserService.ListAllAggregatorUser({}, body)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              // this.users = data.data;
              this.users = data.data.filter(
                (user) => user.user_is_active === "Y"
              );
              console.log("this.users :", this.users);
              // this.getCinemasList();
              // this.getRolesList();
              if (data && data.data.length > 0) {
                if (data.totalRows >= 10) {
                  this.rows = data.totalRows;
                  this.selectedvalue =
                    this.selectedvalue < 10 ? 10 : this.selectedvalue;
                } else {
                  this.rows = data.totalRows;
                  this.selectedvalue = data.totalRows;
                }
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else if (
              data.status == false &&
              data.message == "You are not authorized"
            ) {
              this.$router.push({
                path: "/access-denied",
              });
            } else {
              this.$toasted.show(data.message);
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
              this.users = [];
            }
          })
          .catch(this._CatchError);
      },
      /* eslint-disable */
      onEditUser: function(user) {
        this.$router.push({
          path: "/user-management/edit-aggregator",
          query: { user_id: user.user_id },
        });
      },
      onViewUser: function(user) {
        this.$router.push({
          path: "/user-management/view-aggregator",
          query: { user_id: user.user_id },
        });
      },
      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
      getCinemasList: function(cine_id) {
        this.Cinemas = [];
        console.log("cine_id :", cine_id);
        let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
        MasterService.GlobalRequest(body)
          // MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              // this.users = this.users.map(user => {
              //   this.Cinemas.map(cinema => {
              //     if (String(user.cinema_id) === String(cinema.cine_id)) {
              //       user["cinemaname"] = cinema.cine_name;
              //     }
              //   });
              //   return user;
              // });
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch(this._CatchError);
      },

      getRolesList: function(role_id) {
        console.log("role_id :", role_id);
        this.Roles = [];
        let body = this.getRequestBody("GET", undefined, this.RolesMethod);
        MasterService.GlobalRequest(body)
          // MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.Roles = data.Records;
                // this.users = this.users.map(user => {
                //   this.Roles.map(role => {
                //     if (String(user.role_id) === String(role.role_id)) {
                //       user["rolename"] = role.role_name;
                //     }
                //   });
                //   return user;
                // });
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/UsersComponents/aggregatorUsers.vue